"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _BatchItem = _interopRequireDefault(require("./BatchItem"));

var GridCell = function GridCell(_ref) {
  var rowIndex = _ref.rowIndex,
      columnIndex = _ref.columnIndex,
      style = _ref.style,
      cache = _ref.cache,
      parent = _ref.parent,
      batch = _ref.batch,
      onClick = _ref.onClick,
      onDelete = _ref.onDelete;
  var measureRef = (0, _react.useRef)(function () {});
  var trackCampaignsListBatchesListSelectBatch = (0, _useTrackGiftingFlow.useCampaignsListBatchesListSelectBatch)();
  var handleSelectBatch = (0, _react.useCallback)(function () {
    if (onClick && batch) {
      trackCampaignsListBatchesListSelectBatch({
        batchId: batch.id,
        contactsCount: batch.giftsCount
      });
      onClick();
    }
  }, [batch, trackCampaignsListBatchesListSelectBatch, onClick]);
  (0, _react.useEffect)(function () {
    measureRef.current();
  }, [batch]);
  return /*#__PURE__*/_react.default.createElement(_reactVirtualized.CellMeasurer, {
    cache: cache,
    parent: parent,
    rowIndex: rowIndex,
    columnIndex: columnIndex
  }, function (_ref2) {
    var _batch$defaultProduct, _batch$defaultProduct2, _batch$campaign$name;

    var registerChild = _ref2.registerChild,
        measure = _ref2.measure;
    measureRef.current = measure;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      ref: registerChild,
      style: style
    }, /*#__PURE__*/_react.default.createElement(_BatchItem.default, {
      title: "".concat(batch === null || batch === void 0 ? void 0 : batch.giftsCount, " Contacts - Prospecting"),
      subtitle: (_batch$defaultProduct = batch === null || batch === void 0 ? void 0 : (_batch$defaultProduct2 = batch.defaultProduct) === null || _batch$defaultProduct2 === void 0 ? void 0 : _batch$defaultProduct2.name) !== null && _batch$defaultProduct !== void 0 ? _batch$defaultProduct : 'No default gift selected',
      description: (_batch$campaign$name = batch === null || batch === void 0 ? void 0 : batch.campaign.name) !== null && _batch$campaign$name !== void 0 ? _batch$campaign$name : '',
      loading: !batch,
      onDelete: onDelete,
      onClick: handleSelectBatch
    }));
  });
};

var _default = GridCell;
exports.default = _default;